import { memo, useEffect, useState } from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { default as ReactGA4 } from 'react-ga4';
import { isIABMSelector } from 'src/selectors/app';
import { isLoggedSelector } from 'src/selectors/auth';
import { Button, Container, Element, Image, RouterLink } from 'src/components';
import { isMiniappSelector } from '@zmedia/bm-soccer-ui/selectors/app';

export const ConsentCookies = () => {
    const [isOpen, setOpen] = useState<boolean>(
        (window as any).ZA?.needCookieConsent()
    );
    const isIABM = useSelector(isIABMSelector);
    const isLogged = useSelector(isLoggedSelector);
    const isMiniapp = useSelector(isMiniappSelector);

    const grantedConsent = () => {
        (window as any).ZA?.handleCookieConsentGranted();
        setOpen(false);
    };

    const deniedConsent = () => {
        (window as any).ZA?.handleCookieConsentDenied();
        setOpen(false);
    };

    useEffect(() => {
        if (
            typeof (window as any).ZA?.canWriteCookies === 'function' &&
            !(window as any).ZA?.canWriteCookies() &&
            !isIABM
        ) {
            return;
        }
        ReactGA4.gtag('consent', 'update', {
            ad_user_data: 'granted',
            ad_personalization: 'granted',
            ad_storage: 'granted',
            analytics_storage: 'granted',
        });
    }, [isOpen, isIABM]);

    if (!isOpen || isIABM || isLogged || isMiniapp) {
        return null;
    }

    return (
        <Element
            className={cn(
                'fixed z-[200] left-0 right-0 bottom-0',
                'py-[8px] leading-[16px]',
                'font-medium',
                'bg-[#F6F5F7]'
            )}
        >
            <Container className="flex flex-wrap justify-between items-center max-md:justify-center">
                <Element className="my-[4px] flex items-center">
                    <Image
                        src="https://baomoi-static.bmcdn.me/web/styles/img/ic-info.svg"
                        className="w-[16px] h-[16px] mr-[4px] inline-block"
                    />
                    <Element>
                        Cải thiện trải nghiệm với cookie. Xem{' '}
                        <RouterLink
                            to="/staticpages/privacy.epi"
                            className="underline font-bold"
                            newTab
                        >
                            Chính sách Cookie
                        </RouterLink>
                    </Element>
                </Element>
                <Element>
                    <Button
                        className={cn(
                            'text-[#B1B1B1]',
                            'border-[1px] border-solid border-[#E1DFE5]',
                            'p-[2px_12px]',
                            'rounded-[4px]',
                            'm-[4px]',
                            'h-[28px]'
                        )}
                        onClick={deniedConsent}
                    >
                        Từ chối
                    </Button>
                    <Button
                        className={cn(
                            'text-[#FF9500]',
                            'border-[1px] border-solid border-[#E1DFE5]',
                            'p-[2px_12px]',
                            'rounded-[4px]',
                            'm-[4px]',
                            'h-[28px]'
                        )}
                        onClick={grantedConsent}
                    >
                        Đồng ý
                    </Button>
                </Element>
            </Container>
        </Element>
    );
};

export default memo(ConsentCookies);
